import { setNextTab, setPrevTab, setSelectedTab, setStepperWidth } from "redux/reducers/newCompaignReducer";


export const setNextCompaignTab = () => (dispatch,getState) => {
    const { selectedTab , stepperWidth , tabs , nextTab } = getState().newCompaign;
    const activeTabIndex = tabs?.findIndex(t => t.id === selectedTab.id);
    dispatch(setPrevTab(selectedTab));
    dispatch(setSelectedTab(nextTab));
    dispatch(setNextTab(tabs[activeTabIndex+2]));
    dispatch(setStepperWidth(stepperWidth + 16.6))
}

export const setPrevCompaignTab = () => (dispatch , getState) => {
    const { selectedTab , stepperWidth , prevTab , tabs } = getState().newCompaign;
    const activeTabIndex = tabs?.findIndex(t => t.id === selectedTab.id);
    dispatch(setNextTab(selectedTab));
    dispatch(setSelectedTab(prevTab));
    dispatch(setPrevTab(tabs[activeTabIndex-2]));
    dispatch(setStepperWidth(stepperWidth - 16.6))
}